(function (root) {
  'use strict';
  function modelHandle(href, origin) {
    try {
      const url = new URL(href, origin);
      if (url.origin !== origin) return '';
      const match = url.pathname.match(/^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/collections\/([a-z0-9][a-z0-9-]*)\/?$/i);
      return match ? match[1] : '';
    } catch (_) { return ''; }
  }
  function photoFor(handle, registry, origin) {
    if (!Object.prototype.hasOwnProperty.call(registry, handle)) return null;
    const photo = registry[handle];
    if (!photo || typeof photo.src !== 'string') return null;
    try {
      const url = new URL(photo.src, origin);
      if (url.protocol !== 'https:' || (url.origin !== origin && url.hostname !== 'cdn.shopify.com')) return null;
      return photo;
    } catch (_) { return null; }
  }
  const api = {modelHandle, photoFor};
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (!root || !root.document) return;
  const document = root.document;
  let registry = {};
  try { registry = JSON.parse(document.getElementById('DFVVisualModels')?.textContent || '{}'); } catch (_) {}
  function imageFor(photo, className) {
    const img = document.createElement('img');
    img.className = className;
    img.alt = '';
    img.setAttribute('aria-hidden', 'true');
    img.width = 64;
    img.height = 85;
    img.loading = 'lazy';
    img.decoding = 'async';
    img.src = photo.src;
    if (photo.srcset) { img.srcset = photo.srcset; img.sizes = '(max-width:599px) 56px,64px'; }
    return img;
  }
  function decorate(scope) {
    scope.querySelectorAll('a.dfv-finder__suggestion--model,[data-results] a').forEach(link => {
      if (link.querySelector('.dfv-v2-result-thumb')) return;
      const handle = modelHandle(link.getAttribute('href'), root.location.origin);
      const photo = photoFor(handle, registry, root.location.origin);
      if (!photo) return;
      const img = imageFor(photo, 'dfv-v2-result-thumb');
      const icon = link.querySelector('.dfv-finder__model-icon');
      if (icon) icon.replaceChildren(img); else link.prepend(img);
    });
    const chosen = scope.matches?.('[data-dfv-quickshop]') ? scope : scope.querySelector('[data-dfv-quickshop]');
    if (chosen && !chosen.hidden) {
      const heading = chosen.querySelector('[data-dfv-chosen-model]');
      const href = chosen.querySelector('[data-dfv-all-link]')?.getAttribute('href');
      const photo = photoFor(modelHandle(href, root.location.origin), registry, root.location.origin);
      if (heading && photo && !heading.querySelector('.dfv-v2-chosen-thumb')) heading.prepend(imageFor(photo, 'dfv-v2-chosen-thumb'));
    }
  }
  function hydrate(details) {
    if (!details.open) return;
    details.querySelectorAll('img[data-dfv-v2-src]').forEach(img => {
      img.src = img.dataset.dfvV2Src;
      if (img.dataset.dfvV2Srcset) img.srcset = img.dataset.dfvV2Srcset;
      img.hidden = false;
      img.removeAttribute('data-dfv-v2-src');
      img.removeAttribute('data-dfv-v2-srcset');
    });
  }
  function context() {
    const active = root.DFVCro?.currentType();
    document.querySelectorAll('[data-dfv-v2-question]').forEach(el => { el.hidden = !active; });
  }
  function init() {
    document.querySelectorAll('details[data-v2-models-more]').forEach(details => {
      details.addEventListener('toggle', () => hydrate(details));
      hydrate(details);
    });
    document.querySelectorAll('[data-v2-brand-select]').forEach(button => {
      button.addEventListener('click', () => {
        const directory = button.closest('[id^="dfv-brand-models-"]');
        const target = Array.from(directory?.querySelectorAll('button[data-brand]') || []).find(el => el.dataset.brand === button.dataset.v2BrandSelect);
        if (target) { const disclosure = target.closest('details'); if (disclosure) disclosure.open = true; target.click(); }
        directory?.querySelector('form[data-brand-form]')?.scrollIntoView({block:'start', behavior:root.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      });
    });
    document.querySelectorAll('[data-v2-guide-mid]').forEach(block => {
      const paragraphs = block.parentElement.querySelectorAll(':scope > p');
      if (paragraphs.length > 1) paragraphs[1].insertAdjacentElement('afterend', block);
    });
    document.querySelectorAll('dfv-device-search,[data-results],[data-dfv-quickshop]').forEach(scope => {
      let pending = false;
      const observer = new MutationObserver(() => {
        if (pending) return;
        pending = true;
        root.requestAnimationFrame(() => { pending = false; decorate(scope); });
      });
      observer.observe(scope, {childList:true, subtree:true});
      decorate(scope);
    });
    function selectBrandFromHash() {
      const label = new URLSearchParams(root.location.hash.slice(1)).get('brand');
      if (!label) return;
      const button = Array.from(document.querySelectorAll('[data-v2-brand-select]')).find(el => el.dataset.v2BrandSelect === label);
      button?.click();
    }
    context();
    selectBrandFromHash();
    root.addEventListener('hashchange', context);
    root.addEventListener('hashchange', selectBrandFromHash);
  }
  root.DFVVisual = api;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
})(typeof window === 'undefined' ? null : window);
